import { z } from 'zod';
import { PlatformSchema } from './platform.js';

export const ChatUserRefSchema = z.object({
  platform: PlatformSchema,
  externalId: z.string().min(1),
  displayName: z.string().min(1),
});
export type ChatUserRef = z.infer<typeof ChatUserRefSchema>;

/**
 * Chave estável de identidade — P3. `displayName` muda; nunca deve
 * ser usado como chave. Sempre `(platform, externalId)`.
 */
export function chatUserKey(ref: Pick<ChatUserRef, 'platform' | 'externalId'>): string {
  return `${ref.platform}:${ref.externalId}`;
}
